// extracted by mini-css-extract-plugin
module.exports = {"desktop-menu-espot":"DesktopMenuEspot_desktop-menu-espot__PiXjQ"};